import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	closeModal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bannerAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	premiumIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionSpork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tryItFreeButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionSporkIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closeModal: {
		id: 'jql-builder-with-ai.ai-premium-upsell-button-popup.close-modal',
		defaultMessage: 'Close modal',
		description: 'Label for button closing the modal',
	},
	bannerAltText: {
		id: 'jql-builder-with-ai.ai-premium-upsell-button-popup.banner-alt-text',
		defaultMessage: 'Decorative banner',
		description: 'Alt text for modal banner image',
	},
	premiumIconLabel: {
		id: 'jql-builder-with-ai.ai-premium-upsell-button-popup.premium-icon-label',
		defaultMessage: 'Upgrade to Jira Premium',
		description: 'Label for icon on upgrade to premium button',
	},
	heading: {
		id: 'jql-builder-with-ai.ai-premium-upsell-button-popup.heading',
		defaultMessage: 'No more complex queries',
		description: 'Heading displayed in the AI Premium Upsell Popup',
	},
	descriptionSpork: {
		id: 'jql-builder-with-ai.ai-premium-upsell-button-popup.description-spork',
		defaultMessage:
			'Search for issues in your own words with <link>Atlassian Intelligence (AI)</link>. Try AI with Jira Premium.',
		description: 'Message body text shown in the AI popup component for Org admin user',
	},
	tryItFreeButton: {
		id: 'jql-builder-with-ai.ai-premium-upsell-button-popup.try-it-free-button',
		defaultMessage: 'Try it free',
		description: 'Button to try Jira Software Premium.',
	},
	descriptionSporkIssueTerminologyRefreshM4: {
		id: 'jql-builder-with-ai.ai-premium-upsell-button-popup.description-spork-issue-terminology-refresh-m4',
		defaultMessage:
			'Search for work items in your own words with <link>Atlassian Intelligence (AI)</link>. Try AI with Jira Premium.',
		description: 'Message body text shown in the AI popup component for Org admin user',
	},
});
export default messages;
